import {
  HOME_UPDATE_CLIENT_PROJECT_BEGIN,
  HOME_UPDATE_CLIENT_PROJECT_SUCCESS,
  HOME_UPDATE_CLIENT_PROJECT_FAILURE,
  HOME_UPDATE_CLIENT_PROJECT_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import { builderAuthHeaderWithNoContentType, errorLogOut } from '../../common/utils/auth';

export function updateClientProject(args = {}) {
  return (dispatch) => {
    dispatch({
      type: HOME_UPDATE_CLIENT_PROJECT_BEGIN,
    });
    const { projectId, formData } = args;
    const config = builderAuthHeaderWithNoContentType();
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.put(
        `${process.env.REACT_APP_ORGANIZATION_ENGINE_URL}projects/${projectId}`,
        formData,
        config,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: HOME_UPDATE_CLIENT_PROJECT_SUCCESS,
            data: res,
          });
          resolve(res);
          if (res.status == 200) {
            toast.success('Project updated successfully');
            setTimeout(() => {
              window.location.href = '/dashboard';
            }, 1500);
          }
        },
        (err) => {
          dispatch({
            type: HOME_UPDATE_CLIENT_PROJECT_FAILURE,
            data: { error: err },
          });
          reject(err);
          if (err.response.status == 400) {
            toast.error(err.response.data);
          } else if (err.response.status === 401) {
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'Session Expired',
            }).then((result) => {
              if (result.value) {
                errorLogOut();
              }
            });
          } else {
            toast.error('Failed to update project');
          }
        },
      );
    });

    return promise;
  };
}

export function dismissUpdateClientProjectError() {
  return {
    type: HOME_UPDATE_CLIENT_PROJECT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_UPDATE_CLIENT_PROJECT_BEGIN:
      return {
        ...state,
        updateClientProjectPending: true,
        updateClientProjectError: null,
      };

    case HOME_UPDATE_CLIENT_PROJECT_SUCCESS:
      return {
        ...state,
        updateClientProjectPending: false,
        updateClientProjectError: null,
      };

    case HOME_UPDATE_CLIENT_PROJECT_FAILURE:
      return {
        ...state,
        updateClientProjectPending: false,
        updateClientProjectError: action.data.error,
      };

    case HOME_UPDATE_CLIENT_PROJECT_DISMISS_ERROR:
      return {
        ...state,
        updateClientProjectError: null,
      };

    default:
      return state;
  }
}
